import * as React from 'react';
import { withFormContext } from 'Containers/FormContextHandler';
import type { IFormContext } from 'Containers/FormContextHandler';
import SeizureForm from '../Form/SeizureForm';
import SeizureFreePeriodForm from '../Form/SeizureFreePeriodForm';
import ConfirmedSeizures from './ConfirmedSeizures';
import SeizureFreePeriods from './SeizureFreePeriods';
import HistoryTabs from 'Components/HistoryTabs';
import PatientReportedSeizuresHistory from './PatientReportedSeizures';
import { useSelector } from 'react-redux';
import RejectedSeizures from './RejectedSeizures';
import { filterByDocumentType } from 'Utility/documentHandling';
import type { TRelevantDocumentType } from 'Routes/Seizure/utils';

const SeizureHistory = ({
  props,
  setPatientReportedSeizureFormOpen,
  openTab,
  setOpenTab,
}: IOwnProps): React.JSX.Element => {
  const { documents = [], editing } = props;

  const sortedAndMergedDocs = useSelector((s: IState) => s.myapp.sortedAndMergedDocuments);

  const patientReportedSeizureDocs = filterByDocumentType(sortedAndMergedDocs, 'patientReportedSeizure');
  const seizureTypes = filterByDocumentType(documents, 'seizureType');

  const editingDoc = documents.find(d => d._id === editing);
  const viewDoc = documents.find(d => d._id === props.view?.viewing);

  const seizureDocs = filterByDocumentType(documents, 'seizure').filter(d => d._id !== editing);
  const seizureFreeDocs = filterByDocumentType(documents, 'seizureFreePeriod').filter(d => d._id !== editing);

  return editingDoc || viewDoc?._type === 'seizure' || viewDoc?._type === 'seizureFreePeriod' ? (
    <>
      {(editingDoc?._type === 'seizure' || viewDoc?._type === 'seizure') && <SeizureForm />}
      {(editingDoc?._type === 'seizureFreePeriod' || viewDoc?._type === 'seizureFreePeriod') && (
        <SeizureFreePeriodForm
          documents={[...seizureDocs, ...patientReportedSeizureDocs.filter(d => d.status === 'accepted')]}
        />
      )}
    </>
  ) : (
    <HistoryTabs indexSelectionTools={{ index: openTab, changeFunction: index => setOpenTab(index) }}>
      {[
        {
          title: 'seizure.reportedSeizures',
          content: (
            <PatientReportedSeizuresHistory documents={patientReportedSeizureDocs} seizureTypes={seizureTypes} />
          ),
        },
        {
          title: 'seizure.confirmed',
          content: (
            <ConfirmedSeizures
              documents={seizureDocs}
              patientReportedDocs={patientReportedSeizureDocs}
              setPatientReportedSeizureFormOpen={setPatientReportedSeizureFormOpen}
            />
          ),
        },
        {
          title: 'seizure.rejected',
          content: (
            <RejectedSeizures
              documents={seizureDocs}
              patientReportedDocs={patientReportedSeizureDocs}
              setPatientReportedSeizureFormOpen={setPatientReportedSeizureFormOpen}
            />
          ),
        },
        {
          title: 'seizure.seizureFreePeriods',
          content: <SeizureFreePeriods documents={seizureFreeDocs} />,
        },
      ]}
    </HistoryTabs>
  );
};

interface IOwnProps {
  props: IFormContext<IDocumentWithTypeV2<'seizure' | 'seizureFreePeriod'>, IDocumentWithTypeV2<TRelevantDocumentType>>;
  setPatientReportedSeizureFormOpen: React.Dispatch<
    React.SetStateAction<
      | {
          doc: IDocumentWithTypeV2<'patientReportedSeizure'>;
          type: 'edit' | 'view';
        }
      | undefined
    >
  >;
  openTab: number;
  setOpenTab: React.Dispatch<React.SetStateAction<number>>;
}

export default withFormContext(SeizureHistory);
